<template>
  <c-modal size="lg" title='Multi-analiza' v-model="open">
    <c-row class="u-pb-20 u-pt-20 u-font-bold">
      <c-col>Files to upload:</c-col>
    </c-row>
    <c-scroll-view style="height:400px">
      <c-row :class="{'u-bg-grey-lightest': index % 2}" :key="file.id" align="middle" v-for="(file,index) in files">
        <c-col span="16">
          {{file.name}}
        </c-col>
        <c-col span="7">
        </c-col>
        <c-col>
          <span v-if="file.error"><i class="icon-notification2 u-color-danger"
                                     v-tooltip="file.error"></i></span>
          <span v-else-if="file.success"><i class="icon-checkmark u-color-success"></i></span>
          <span v-else-if="file.active"><i class="i-spinner"></i></span>
          <span v-else>
          <a @click.prevent="$refs.multiproc_upload.remove(file)" href="#"><i class="icon-bin"></i></a>
                </span>
        </c-col>
      </c-row>
    </c-scroll-view>
    <c-row>
      <c-col></c-col>
    </c-row>
    <c-row>
      <c-col>
      </c-col>
    </c-row>
    <div class="u-text-right" slot="footer">
      <a class="u-fl" href="#" v-show="!is_uploading">
      <span class="i-text">
        <file-upload
          :accept="accept"
          :add-index="addIndex"
          :data="data"
          :directory="directory"
          :drop="drop"
          :drop-directory="dropDirectory"
          :extensions="extensions"
          :headers="headers"
          :multiple="multiple"
          :post-action="postAction"
          :put-action="putAction"
          :size="size || 0"
          :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
          @input-file="inputFile"
          @input-filter="inputFilter"
          class="btn btn-primary dropdown-toggle"
          ref="multiproc_upload"
          v-model="files">
            <i class="icon-plus"></i>
            Select files
        </file-upload>
      </span>
      </a>
      <c-button :disabled="is_uploading" @click="onContinue" type="primary">Continue</c-button>
      <c-button @click="onCancel">Close</c-button>
    </div>
  </c-modal>
</template>

<script>
  import {mapState} from 'vuex'
  // import axios from 'axios'
  import batches from '../../../services/batches.service'

  export default {
    name: 'OtpLeasingBatchMultiproc',

    components: [],

    computed: {
      ...mapState('auth', ['clientCode']),
      ...mapState('client', ['requestProperties'])
    },

    data () {
      return {
        open: false,
        props: [],
        propValues: {},
        onCompleteCallback: null,
        onCancelCallback: null,

        is_uploading: false,

        // for upload component
        files: [],
        accept:
          'application/pdf',
        extensions: 'pdf',
        minSize: 1,
        size: 1024 * 1024 * 30,
        multiple: true,
        directory: false,
        drop: true,
        dropDirectory: false,
        addIndex: true,
        thread: 1,
        name: 'file',
        postAction: process.env.API + 'upload/post',
        putAction: '',
        headers: {
          // 'X-Csrf-Token': 'xxxx',
          Authorization: 'Basic xxx'
        },
        data: {
          _csrf_token: 'xxxxxx'
        },

        autoCompress: 1024 * 1024,
        uploadAuto: false,

        editFile: {
          show: false,
          name: ''
        }
      }
    },

    methods: {
      run (onCompleteCallback, onCancelCallback) {
        this.onCompleteCallback = onCompleteCallback
        this.onCancelCallback = onCancelCallback
        this.props = this.requestProperties
        this.files = []
        this.propValues = {}
        this.is_uploading = false

        this.open = true
      },

      onCancel () {
        if (!this.is_uploading) {
          this.open = false
          return
        }

        let ask = false
        for (const f of this.files) {
          if (f.error || f.success) {
            continue
          } else {
            ask = true
            break
          }
        }
        if (ask) {
          this.$alert({
            type: 'info',
            title: 'Pending uploads',
            content: 'Not all files were uploaded, continue?\r\nThis will not however stop the upload',
            showCancel: true,
            cancelText: 'No',
            continueText: 'Yes',
            onConfirm: () => {
              this.open = false
            },
            onCancel: () => {
              // do something..
              // if you want to stop closing alert, just return false
            }
          })
        } else {
          this.open = false
        }
      },

      async onContinue () {
        if (this.is_uploading) {
          return
        }

        // let messages = []
        let error = ''

        if (error === '') {
          if (this.files.length === 0) {
            error = 'Please select at least one file'
          }
        }

        if (error !== '') {
          this.$snotify.error(error, {
            position: 'centerTop',
            timeout: 6000,
            showProgressBar: false
          })

          return
        }

        try {
          this.is_uploading = true
          await this._upload()
          // this.open = false
          // this.is_uploading = false
        } catch (e) {
          this.is_uploading = false
          console.log('Error while uploading batch', e)
          this.$snotify.error('An error occured while uploading the files to the server', {
            position: 'centerTop',
            timeout: 6000,
            showProgressBar: false
          })
        }
      },

      async _createBatch () {
        let batchId = batches.uuidv4()
        let batchDetails = []

        let pr = {}
        for (const p of this.props) {
          if (p.is_visible && p.allows_manual_input) {
            pr[p.property_code] = this.propValues[p.property_code]
          }
        }

        for (const f of this.files) {
          f.data['request_id'] = batches.uuidv4()
          batchDetails.push({
            'batch_id': batchId,
            'batch_detail_id': batches.uuidv4(),
            'client_request_id': f.data['request_id'],
            'properties': {
            }
          })
        }

        let re = {
          'batch_id': batchId,
          'batch_type': 'MULTIPROC',
          'batch_name': 'Formular.multiprocesare',
          'properties': pr,
          'details': batchDetails
        }
        await batches.createBatch(this.clientCode, re)
      },

      async _upload () {
        await this._createBatch()

        for (const f of this.files) {
          for (const p of this.props) {
            if (p.is_visible && p.allows_manual_input) {
              f.data[p.property_code] = this.propValues[p.property_code]
            }
          }
          // mark this is part of a batch
          f.data['belongs_to_batch'] = 'true'
          f.data['client'] = this.clientCode

          f.headers['Authorization'] = `Bearer ${this.$auth.getAccessToken()}`
          this.$refs.multiproc_upload.update(f.id, {active: true})
        }
      },

      inputFile (newFile, oldFile) {
        if (newFile) {
          newFile.headers['Authorization'] = `Bearer ${this.$auth.getAccessToken()}`
          this._updateRole(newFile)
        }
      },

      inputFilter (newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file

          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }

          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }

        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
          // Create a blob field
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Clients/OTPLeasing/BatchMultiproc.vue